import React, {
    useCallback,
} from 'react';
import {
    Button,
    ModalNext,
    ModalHeader,
    ModalBody,
    ModalFooter,
    TextAreaField
} from '@jutro/components';

function ConditionTextClaimDetailPopUp(props) {
    const {
        isOpen,
        modalTitle,
        description,
        defaultButtonLabel,
        onReject
    } = props;

    const handleDefaultAction = useCallback(() => {
        onReject();
    }, [onReject]);

    return (
        <ModalNext isOpen={isOpen}>
            <ModalHeader title={modalTitle} />
            <ModalBody>
                <TextAreaField
                    autoTrim={false}
                    dataType="string"
                    disabled={false}
                    hideLabel={false}
                    id="textareaDescripcion"
                    labelPosition="top"
                    maxLength={200}
                    readOnly
                    rows={3}
                    schemaRequired={false}
                    showErrors={false}
                    showValidationIcon={false}
                    value={description}
                />
            </ModalBody>
            <ModalFooter>
                <Button
                    onClick={handleDefaultAction}
                >
                    {defaultButtonLabel}
                </Button>
            </ModalFooter>
        </ModalNext>
    );
}

ConditionTextClaimDetailPopUp.defaultProps = {
    isOpen: false
};
export default ConditionTextClaimDetailPopUp;
